import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { TransportRapporteringPage } from 'pages/app/naturvardsverket/transport-rapportering/TransportRapporteringPage'
import { getWaste } from 'api/waste.api'

const transportRapporteringSearchSchema = z.object({
  wasteid: z.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/app/avfallsregistret/rapportera-transport'
)({
  validateSearch: transportRapporteringSearchSchema,
  beforeLoad: async ({ context: { queryClient }, search }) => {
    if (search.wasteid) {
      await queryClient.ensureQueryData(getWaste(search.wasteid))
    }
  },
  component: TransportRapporteringPage,
})
